import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCard = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 22,
			height: 32,
			rx: 2,
			fill: "#1F1F1F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 5,
			width: 6,
			height: 4,
			rx: .5,
			fill: "#F9DBA4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			opacity: .5,
			cx: 15,
			cy: 27,
			r: 2,
			fill: "#EAB308"
		}),
		/* @__PURE__ */ _jsx("circle", {
			opacity: .5,
			cx: 18,
			cy: 27,
			r: 2,
			fill: "#FF5626"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M9.99998 7.99997H8H12M9.99998 7.99997H12M8.00014 6.14282L10.0002 6.14286V7.07139L9.99998 7.99997M13.9999 7.99997H12M12 7.99997L12.0002 7.07139M14.0001 6.14282H12.0002V7.07139M12.0002 7.07139H14.0001M10.0002 7.07139H8.00014",
			stroke: "black",
			strokeWidth: .5
		})
	]
});
const ForwardRef = forwardRef(SvgCard);
export default ForwardRef;
